import { Gender } from '@pipes';
import { Address, UserRoleType, UserRoleTypeUpperCase } from '../../models';
import { UserState } from '../..';
import { APPLICATION_ROLES, IAMRoles } from '@store';

export enum Salutation {
  Mrs = 'Mrs',
  Mr = 'Mr',
}

export interface User {
  id: number;
  viAccount: string;
  salutation: Salutation;
  salutationV2: string;
  firstName: string;
  lastName: string;
  email: string;
  emailVerified: boolean;
  mobile: string;
  phoneNumber: string;
  faxNumber: string;
  locale: string;
  address: Address;
  role: UserRoleType;
  group: string;
  businessPartnerId: string;
  createdAt: string;
  editedAt: string;
  privacyPolicyAcceptedAt: string; // Date
  privacyPolicyRequester: string;
  isDeleted: boolean;
  companyName?: string;
  familyName?: string;
}

export interface UserV2 {
  id: string;
  loginId: string;
  languageCode: string;
  gender: Gender;
  userState: UserState;
  identityType: IAMRoles;
  title: string;
  name: {
    firstName: string;
    familyName: string;
  };
  contacts: {
    email: string;
    emailVerified: boolean;
    telephone: string;
    mobile: string;
    telefax: string;
  };
  address: {
    street: string;
    city: string;
    houseNumber: string;
    postalCode: string;
    countryCode: string;
    locality: string;
    country: string;
  };
  applicationRoles: APPLICATION_ROLES[];
  company: {
    id: string;
    name: string;
    companyEmail: string;
    companyPhone: string;
    companyCountryCode: string;
  };
  sfIndividualId: string;
  locale: string;
  isLite: boolean;
  salutation: string;
  iotRole: UserRoleTypeUpperCase;
  iotRoleV2: string;
  iotRoleV2Permissions: string[];
  editedAt: string;
  bpValidationStatus: string;
  createdAt: string;
  updatedAt: string;
}

export interface UserV3 {
  id: string;
  salutation: Salutation;
  firstName: string;
  familyName: string;
  email: string;
  mobile: string;
}
export interface UsersQueryParams {
  email?: string;
  limit?: number;
  cursor?: string;
  customerNumber?: string;
}

export interface UserInstallationsParams {
  cursor?: string;
  limit?: number;
}

export interface UpdateUserRequest {
  role: UserRoleType;
}

export interface CompanyUser {
  firstName: string;
  familyName: string;
  email: string;
  login: string;
  businessRole: string;
  sfId: string;
  iamId: string;
  salutation: string;
}

export interface AccountByCompany {
  [companyCode: string]: CompanyUser[];
}
